import { checkPartnerEmailPatternInList } from '../../../../../common';
import { mustNotBeBlankValidator } from '../../../../../common/utils';
import { FormControl, Validators } from '@angular/forms';
import { PartnerModel } from './partner.model';
import { PartnerOnboardingStatus, PartnerRegion, PartnerType } from '../constants';

export class PartnerDetailsModel {
  id?;
  approved = false;
  active = true;
  name: string | null = null;
  contactEmails: string[] = [];
  partnerType: PartnerType = PartnerType.Carrier;
  region?: PartnerRegion;
  country: string | null = null;
  city: string | null = null;
  streetName: string | null = null;
  streetNumber: string | null = null;
  zipCode: string | null = null;
  shortName: string | null = null;
  onboardingStatus: PartnerOnboardingStatus = PartnerOnboardingStatus.NotOnboarded;
  dataQualityEmails: string[] = [];
  milestoneReportEnabled = false;
  milestoneReportEmails: string[] = [];
  milestoneReportDays: string[] = [];
  milestoneReportHour: number | null = null;

  constructor(params?: PartnerDetailsModel | PartnerModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class PartnerDetailsForm {
  id?: FormControl<number>;
  region?: FormControl<PartnerRegion>;

  constructor(
    detailsModel: PartnerDetailsModel,
    hasUpdatePermission: boolean = true,
    public name: FormControl<string> = new FormControl({ value: detailsModel.name, disabled: !hasUpdatePermission }, [
      Validators.maxLength(50),
      Validators.required,
      mustNotBeBlankValidator,
    ]),
    public contactEmails: FormControl<string[]> = new FormControl(
      { value: detailsModel.contactEmails, disabled: !hasUpdatePermission },
      [checkPartnerEmailPatternInList],
    ),
    public partnerType: FormControl<PartnerType> = new FormControl(
      { value: detailsModel.partnerType, disabled: !!detailsModel.id },
      [Validators.required],
    ),
    public active: FormControl<boolean> = new FormControl(
      { value: detailsModel.active, disabled: !hasUpdatePermission },
      [Validators.required],
    ),
    public approved: FormControl<boolean> = new FormControl(detailsModel.approved, [Validators.required]),
    public country: FormControl<string> = new FormControl(
      { value: detailsModel.country, disabled: !hasUpdatePermission },
      [Validators.required],
    ),
    public city: FormControl<string> = new FormControl({ value: detailsModel.city, disabled: !hasUpdatePermission }, [
      Validators.required,
      mustNotBeBlankValidator,
    ]),
    public zipCode: FormControl<string> = new FormControl(
      { value: detailsModel.zipCode, disabled: !hasUpdatePermission },
      [Validators.required, mustNotBeBlankValidator],
    ),
    public streetName: FormControl<string> = new FormControl(
      { value: detailsModel.streetName, disabled: !hasUpdatePermission },
      [Validators.required, mustNotBeBlankValidator],
    ),
    public streetNumber: FormControl<string> = new FormControl(
      { value: detailsModel.streetNumber, disabled: !hasUpdatePermission },
      [Validators.required, mustNotBeBlankValidator],
    ),
    public shortName: FormControl<string> = new FormControl(
      { value: detailsModel.shortName, disabled: !hasUpdatePermission },
      [Validators.maxLength(10)],
    ),
    public onboardingStatus: FormControl<PartnerOnboardingStatus> = new FormControl(
      { value: detailsModel.onboardingStatus, disabled: !hasUpdatePermission },
      [Validators.required],
    ),
    public dataQualityEmails: FormControl<string[]> = new FormControl(
      { value: detailsModel.dataQualityEmails, disabled: !hasUpdatePermission },
      [checkPartnerEmailPatternInList],
    ),
    public milestoneReportEnabled: FormControl<boolean> = new FormControl({
      value: detailsModel.milestoneReportEnabled,
      disabled: !hasUpdatePermission,
    }),
    public milestoneReportEmails: FormControl<string[]> = new FormControl(
      { value: detailsModel.milestoneReportEmails, disabled: !hasUpdatePermission },
      [checkPartnerEmailPatternInList],
    ),
    public milestoneReportDays: FormControl<string[]> = new FormControl(
      { value: detailsModel.milestoneReportDays, disabled: !hasUpdatePermission },
      [],
    ),
    public milestoneReportHour: FormControl<number> = new FormControl(
      { value: detailsModel.milestoneReportHour, disabled: !hasUpdatePermission },
      [],
    ),
  ) {
    if (detailsModel.id) {
      this.id = new FormControl(detailsModel.id, []);
    }
    if (detailsModel.region) {
      this.region = new FormControl({ value: detailsModel.region, disabled: true }, []);
    }
  }
}
